exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[data-v-534ba82e]::-webkit-inner-spin-button,input[data-v-534ba82e]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number][data-v-534ba82e]{-moz-appearance:textfield}.tanpawrap[data-v-534ba82e]{white-space:nowrap}", ""]);

// exports
